export enum BoxType {
  SAVER_BOX = 'saver_box',
  FLEX_BOX = 'flex_box',
}

export type BoxWithPlan = {
  boxId: string
  boxName: string
  boxDisplayName: string
  boxType: BoxType
  description: string
  weightLb: number
  weightOz: number
  boxPlan: BoxPlan[]
  frequency: number
}

export type Box = {
  boxId: string
  boxName: string
  boxDisplayName: string
  boxType: BoxType
  description: string
  weightLb: number
  weightOz: number
}

export type BoxPlan = {
  boxPlanId: number
  boxId: string
  planId: string
  defaultPrice: number
  proteinCode?: string
  description?: string
}

export enum FreezeDriedBoxId {
 BEEF = 'fd-small-box-beef',
 CHICKEN = 'fd-small-box-chicken',
 MIXED = 'fd-small-box-mixed'
}

export enum VenisonBoxId {
  SMALL = 'fr-small-box-venison',
  BIG = 'fr-big-box-venison',
}

export enum EssentialBoxId {
  SMALL = 'small-box',
  CLASSIC = 'classic-box',
  BIG = 'big-box',
}

export type FreezeDriedBox = {
  boxId: FreezeDriedBoxId
}
